import React from 'react';
import {Redirect, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';

import logoAssets from 'assets/assets.js';

import Footer from 'components/Footer';
import Header from 'components/Header';
import LandingPage from 'components/LandingPage';
import Login from 'components/Login';

import './styles.scss';

const LandingPagePage = ({settings, styleSheet}) => {
  const location = useLocation();

  const authenticated = useSelector((state) => state.login.get('authenticated'));

  const currentRoute = location.pathname;
  if (authenticated && currentRoute === '/login') {
    return (<Redirect to={{
      pathname: '/'
    }}
    />);
  }

  return (
    <div
      data-page={'LandingPage'}
    >

      <Header
        logoAssets={logoAssets}
        settings={settings}
        styleSheet={styleSheet}
      />

      <div className='main-content'>
        {currentRoute === '/login' && <Login styleSheet={styleSheet}/>}
        {currentRoute === '/' && <LandingPage settings={settings} styleSheet={styleSheet}/>}
      </div>

      <Footer
        settings={settings}
        styleSheet={styleSheet}
        logoAssets={logoAssets}
      />
    </div>
  );
};

export default LandingPagePage;
